<template>
  <div class="tx-products module-filter-sorting" :class="{'-open': opened}">
    <div class="level1__label" @click="changeOpened()"><span>{{ $t('productList.sorting.open') }}</span></div>
    <div class="level1__label-mobile" @click="changeOpened()"><span class="icon-sort-before">{{ $t('productList.sorting.openMobile') }}</span></div>
    <div class="form level1__categories-wrapper">
      <div class="level1__categories-close icon-close-x-after" @click="$emit('closeDropdown')"></div>
      <div class="form-group">
        <div class="checkbox" :class="{ '-checked': sortingRelevance }">
          <label class="form-check-label">
            <input type="checkbox" :id="'relevance'" v-model="valueRelevance" @change="$emit('checkboxChange', $event)">
            <span>{{ $t('productList.sorting.relevance') }}</span>
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="checkbox" :class="{ '-checked': sortingAsc }">
          <label class="form-check-label">
            <input type="checkbox" :id="'asc'" v-model="valueAsc" @change="$emit('checkboxChange', $event)">
            <span>{{ $t('productList.sorting.asc') }}</span>
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="checkbox" :class="{ '-checked': sortingDsc }">
          <label class="form-check-label">
            <input type="checkbox" :id="'dsc'" v-model="valueDsc" @change="$emit('checkboxChange', $event)">
            <span>{{ $t('productList.sorting.dsc') }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'ProductSorting',
  props: {
    level1: {
      type: Object,
      default: () => {
      }
    },
    opened: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      sortingAsc: state => state.filter.sortingAsc,
      sortingDsc: state => state.filter.sortingDsc,
      sortingRelevance: state => state.filter.sortingRelevance
    }),
    valueAsc: {
      get () {
        return this.sortingAsc
      },
      set (value) {
        this.$store.commit('filter/setSortingAsc', value)
      }
    },
    valueDsc: {
      get () {
        return this.sortingDsc
      },
      set (value) {
        this.$store.commit('filter/setSortingDsc', value)
      }
    },
    valueRelevance: {
      get () {
        return this.sortingRelevance
      },
      set (value) {
        this.$store.commit('filter/setSortingRelevance', value)
      }
    }
  },
  methods: {
    changeOpened () {
      if (this.opened) {
        this.$emit('closeDropdown')
      } else {
        this.$emit('openDropdown')
      }
    }
  }
}
</script>
